<template>
  <div>
    <ValidationProvider
        :name="formRow.name"
        :rules="rules"
        v-slot="{ passed, failed }"
    >
      <md-datepicker
          :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
          format="DD/MM/YYYY"
          :name="formRow.name"
          v-model="value"
      >
        <label class="label-datepicker">{{ $t(formRow.title) }}</label>
      </md-datepicker>
      <p v-if="failed" style="text-align: left;">
        <b
            v-if="formRow.attr.validations.length > 0"
            class="text-danger"
        >
          {{ formRow.attr.validations[0].message }}
        </b>
      </p>
    </ValidationProvider>
  </div>
</template>
<script>
import {extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", required);
export default {
  name: "DateInput",
  props: {
    objeto: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    formRow: {
      type: Object,
      default: function () {
        return {};
      },
      require: true
    },
    field_index: {
      type: Number,
      default: -1,
      required: false
    }
  },
  data() {
    return {
      obj: this.objeto
    };
  },
  computed: {
    value: {
      get() {
        return this.obj[this.formRow.name]
            ? this.obj[this.formRow.name]
            : null;
      },
      set: function (newValue) {
        this.obj[this.formRow.name] = newValue;
        this.$emit("on-update", {name: this.formRow.name, value: newValue});
      }
    }
  },
  created() {
    if (this.formRow.attr.validations.length > 0) {
      this.rules = "required";
    }
  },
  methods: {}
};
</script>
